// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/lifestyle-item/lifestyle-item.component.scss
// module id = 115
// module chunks = 0